module.exports = __webpack_public_path__ + "static/media/1019034.8e8b4ee2.jpg";